// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const milotic: PokeData = {
  "id": 350,
  "name": "milotic",
  "height": 62,
  "weight": 1620,
  "base_experience": 189,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "wrap",
    "water-gun",
    "hydro-pump",
    "surf",
    "recover",
    "splash",
    "flail",
    "attract",
    "safeguard",
    "twister",
    "rain-dance",
    "refresh",
    "water-sport",
    "water-pulse",
    "aqua-ring",
    "aqua-tail",
    "captivate",
    "coil",
    "dragon-tail",
    "disarming-voice",
    "life-dew"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "splash",
    "rain-dance",
    "refresh",
    "aqua-tail",
    "life-dew",
    "bubble-beam",
    "water-spout",
    "aqua-jet",
    "bubble",
    "whirlpool",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 178,
    "item": null,
    "species": [
      {
        "name": "feebas",
        "order": 377,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "milotic",
        "order": 378,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 349,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": 170,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 141,
    "speed": 116,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
